import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { PlaylistComponent } from './playlist/playlist.component';

import { AuthGuard } from './shared/guards/auth.guard';
import { GuestGuard } from './shared/guards/guest.guard';
import { UserMgmtComponent } from './user-mgmt/user-mgmt.component';
import { MenuComponent } from './menu_mgt/menu/menu.component';
import { DataComponent } from './menu_mgt/data/data.component';
import { LogComponent } from './menu_mgt/log/log.component';
import { ReportsComponent } from './menu_mgt/reports/reports.component';
import { TosComponent } from './menu_mgt/tos/tos.component';
import { UserGroupsComponent } from './menu_mgt/user-groups/user-groups.component';
import { ProfileComponent } from './menu_mgt/profile/profile.component';
import { MenuUserComponent } from './menu_mgt/menu-user/menu-user.component';
import { ComposerRootComponent } from './composer/composer-root/composer-root.component';
import { ProComponent } from './composer/pro/pro.component';
import { CreateAccountComponent } from './composer/create-account/create-account.component';
import { CoWritersComponent } from './composer/co-writers/co-writers.component';
import { MyUploadComponent } from './composer/my-upload/my-upload.component';
import { PaymentComponent } from './composer/payment/payment.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TosCompComponent } from './composer/tos/tos.component';
import { HomeComposerComponent } from './composer/home-composer/home-composer.component'
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CmsComponent } from './menu_mgt/cms/cms.component';
import { SupportUserInputComponent } from './menu_mgt/support-user-input/support-user-input.component';
import { SupportComponent } from './menu_mgt/support/support.component';
import { DataDashboardComponent } from './shared/data_components/data-dashboard/data-dashboard.component';
import { DataProComponent } from './shared/data_components/_pro_tab_views/data-pro/data-pro.component';
import { DataPartnerComponent } from './shared/data_components/_partner_tab_views/data-partner/data-partner.component';
import { PartnerDetailsComponent } from './shared/data_components/_partner_tab_views/partner-details/partner-details.component';
import { PartnersListComponent } from './shared/data_components/_partner_tab_views/partners-list/partners-list.component';
import { SuperAdminProImportComponent } from './shared/data_components/_pro_tab_views/super-admin-pro-import/super-admin-pro-import.component';
import { ProImportComponent } from './shared/data_components/_pro_tab_views/pro-import/pro-import.component';
import { SuperAdminProMapLabelsComponent } from './shared/data_components/_pro_tab_views/super-admin-pro-map-labels/super-admin-pro-map-labels.component';
import { ReadyToMapComponent } from './shared/data_components/_pro_tab_views/ready-to-map/ready-to-map.component';
import { PartnerGroupShowMapperComponent } from './shared/data_components/_pro_tab_views/partner-group-show-mapper/partner-group-show-mapper.component';
import { ProArchiveComponent } from './shared/data_components/_pro_tab_views/pro-archive/pro-archive.component';
import { PartnerManagementComponent } from './shared/data_components/_partner_tab_views/partner-management/partner-management.component';
import { PartnerGroupManagementComponent } from './shared/data_components/_partner_tab_views/partner-group-management/partner-group-management.component';
import { DataManagementComponent } from './shared/data_components/_management_tab_views/data-management/data-management.component';
import { ImportManagementComponent } from './shared/data_components/_management_tab_views/import-management/import-management.component';
import { ShowMapperTableComponent } from './shared/data_components/data-pro-new/show-mapper-table/show-mapper-table.component';
import { PartnerGroupMapperTableComponent } from './shared/data_components/data-pro-new/partner-group-mapper-table/partner-group-mapper-table.component';


const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent, canActivate: [GuestGuard] },
  { path: 'playlists', component: PlaylistComponent },
  { path: 'user-mgmt', redirectTo: 'user-mgmt/users', pathMatch: 'full' },
  { path: 'user-mgmt/users', redirectTo: 'user-mgmt/users/clients', pathMatch: 'full' },
  { path: 'user-mgmt/users/clients', component: UserMgmtComponent, canActivate: [AuthGuard] },
  { path: 'user-mgmt/users/artists', component: UserMgmtComponent, canActivate: [AuthGuard] },
  { path: 'user-mgmt/groups', component: UserMgmtComponent, canActivate: [AuthGuard] },
  { path: 'user-mgmt/templates', component: UserMgmtComponent, canActivate: [AuthGuard] },
  { path: 'user-mgmt/campaigns', component: UserMgmtComponent, canActivate: [AuthGuard] },

  {
    path: 'menu', component: MenuComponent, children: [
      {
        path: 'menu',
        redirectTo: 'data',
        pathMatch: 'full'
      },
      { path: 'users', component: MenuUserComponent },
      { path: 'data', component: DataComponent },
      { path: 'log', component: LogComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'tos', component: TosComponent },
      { path: 'user-groups', component: UserGroupsComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'cms', component: CmsComponent },
      { path: 'supportUser', component: SupportComponent },
    ]
  },
  { path: 'dashboard', component: DashboardComponent },
  {
    path: 'composer', component: ComposerRootComponent, children: [
      {
        path: 'composer',
        redirectTo: 'user-account',
        pathMatch: 'full'
      },
      { path: 'pro', component: ProComponent },
      { path: 'user-account', component: CreateAccountComponent },
      { path: 'co-writer', component: CoWritersComponent },
      { path: 'payment', component: PaymentComponent },
    ]
  },
  { path: 'composer/term-condition', component: TosCompComponent, canActivate: [AuthGuard] },

  { path: 'composer/my-tracks', component: HomeComposerComponent },

  { path: 'composer/my-uploads', component: MyUploadComponent },

  { path: 'reset-password', component: ResetPasswordComponent },

  { path: 'data', component: DataDashboardComponent, canActivate: [AuthGuard], data: { guardMethod: 'canActivateDataDashboard' } },
  { path: 'data/pro', component: DataProComponent, canActivate: [AuthGuard], data: { guardMethod: 'canActivateDataDashboard' }, children: [
    {
      path: 'import-details',
      component: ProImportComponent
    },
    {
      path: 'import', 
      component: SuperAdminProImportComponent
    },
    {
      path: 'label-mapper',
      component: SuperAdminProMapLabelsComponent
    },
    {
      path: 'label-mapper/:importId',
      component: SuperAdminProMapLabelsComponent
    },
    {
      path: 'ready-to-map',
      component: ReadyToMapComponent
    },
    {
      path: 'partner-group-show-mapper',
      component: PartnerGroupShowMapperComponent,
      pathMatch: 'full' // Optional: Use this if 'partner-group-show-mapper' is a standalone route
    },
    {
      path: 'partner-group-show-mapper/:profileId', // Define the parameter name in the path
      component: PartnerGroupShowMapperComponent
    },
    {
      path: 'archive',
      component: ProArchiveComponent
    }
    
  ] },

  {
    path: 'data/partners', component: DataPartnerComponent, canActivate: [AuthGuard], data: { guardMethod: 'canActivateDataDashboard' }, children: [
      {
        path: 'lists',
        component: PartnersListComponent,
        children: [
          {
            path: 'partners-list',
            component: PartnerManagementComponent
          },
          {
            path: 'partner-groups-list',
            component: PartnerGroupManagementComponent,
            data: {partnerGroupId: null} //optional parameter
          },
          {
            path: 'partner-groups-list/:partnerGroupId',
            component: PartnerGroupManagementComponent
          }
        ]
      },
      {
        path: 'details/:partnerId',
        component: PartnerDetailsComponent
      }
    ]
  },

  { path: 'data/management', component: DataManagementComponent, canActivate: [AuthGuard], data: { guardMethod: 'canActivateDataDashboard'} },
  { path: 'data/import-management', component: ImportManagementComponent, canActivate: [AuthGuard], data: { guardMethod: 'canActivateDataDashboard'} },
  { path: 'data/pro/show-mapper', component: ShowMapperTableComponent, canActivate: [AuthGuard], data: { guardMethod: 'canActivateDataDashboard'} },
  { path: 'data/pro/partner-group-mapper', component: PartnerGroupMapperTableComponent, canActivate: [AuthGuard], data: { guardMethod: 'canActivateDataDashboard'} }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
